import type { MapSystem } from '@stars-and-ships/api-types';

/** "You [VAN]", "Ally · Orion [VAN]", "Kestrel [RED]", "Lone" or "Unowned" — the tag whenever there is one. */
export function ownerTag(
  system: Pick<MapSystem, 'owner'>,
  me: { playerId: string; allianceId: string | null } | undefined
): string {
  const { owner } = system;
  if (!owner) return 'Unowned';
  const tag = owner.alliance ? ` [${owner.alliance.tag}]` : '';
  if (owner.playerId === me?.playerId) return `You${tag}`;
  if (me?.allianceId && owner.alliance?.id === me.allianceId) {
    return `Ally · ${owner.displayName}${tag}`;
  }
  return `${owner.displayName}${tag}`;
}
